// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2zsuP","boxTitle":"Qualiphy_boxTitle__3vAk2","box":"Qualiphy_box__3ddTB","toggleWrap":"Qualiphy_toggleWrap__55j5W"};